import React, { Component , Fragment } from 'react';
import './ProgramarMto.css';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { 
  TextField,
 
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  CircularProgress,
  FormControl,
  
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Typography
} from '@mui/material';

import MyButton from '../../../utils/MyButton';



import { getTecnicos} from '../../../redux/actions/useractions';

import { FaArrowLeft,FaPlus,FaCalendarPlus, FaCheckCircle, FaCheck } from "react-icons/fa";

import {progMto,clearErrors} from '../../../redux/actions/dataactions';


export class ProgramarMto extends Component {

    constructor(){
        super();
        this.state={
            servicio: '',
            idprestador: '',
            fecha: '',
            frecuencia: 'riesgo', 
            responsable: '',
            fecha:'',
            hora:'',
            duracion:'',
            actividades:"Verificación General, Limpieza General, Verificación de Funcionamiento, Actividades Recomendadas por el Fabricante, Reemplazo de componentes desgastados",
            errors:{},
            aprobado:{},
            open:false
        };
        
    };
    static getDerivedStateFromProps(props, state) {
      const newState = {};
  
      if (props.UI.errors) {
          newState.errors = props.UI.errors;
      }
  
      if (props.UI.aprobado) {
         newState.aprobado = props.UI.aprobado;
      }
  
      return Object.keys(newState).length > 0 ? newState : null;
  }
  

    handleOpen=()=>{
        this.setState({open:true,aprobado:{}});
         this.props.getTecnicos(this.props.handleuser);
        };

     handleClose=()=>{
            this.props.clearErrors();
            this.setState({open:false,errors:{},aprobado:{}});
            };
        
     handleChange=(event)=>{
     this.setState({[event.target.name]:event.target.value});
     
     };

     
    handleSubmit=(event)=>{
        event.preventDefault();
      const { credentials } = this.props.user;
          let responsable = "Todos"; // por defecto para técnicos

          if (credentials.tipouser === "Tecnico") {
            responsable = credentials.handle;
          }
         
       

        const newProgramacion={
          fecha:this.state.fecha,
          hora:this.state.hora,
          idprestador: this.props.clienteId,
          responsable: this.state.responsable,
          frecuencia: this.state.frecuencia,
          actividades:this.state.actividades,
          
          nombre:this.props.equipo.nombre,
          marca:this.props.equipo.marca,
          modelo:this.props.equipo.modelo,
          serie:this.props.equipo.serie,
          ubicacion:this.props.equipo.ubicacion,
          servicio:this.props.equipo.servicio,
          idinventario:this.props.equipo.idinventario
             
      };

     this.props.progMto(newProgramacion,this.props.equipoId); 
        //Aqui se postea al cliente
     
    
        }
        

    render() {

        const { UI:{loading}}=this.props; 
          const { errors, frecuencia } = this.state;

        return (
            <Fragment>
            
            <MyButton tip="Programar Mantenimiento Preventivo" onClick={this.handleOpen}>
            <FaCalendarPlus color="#03178C" className="icon-crearcliente"/>
             </MyButton>

             <Dialog
             open={this.state.open}
             onClose={this.handleClose}
             fullWidth
            maxWidth="sm"
            >
                {this.state.aprobado.mensaje ? (
              
              <div className='div-aprobado'>
                  <div className='div-icono-aprobado'>
                    <FaCheck color="#ffffff" className='icono-aprobado'/>
                  </div>
                  <h2 className='text-aprobado'>¡Programación de Mantenimiento Exitosa!</h2>
              </div>
                
                ) : (<div>
                    <DialogTitle >
                              <Typography sx={{ 
                                                                         fontSize: '20px', 
                                                                         fontWeight: 600, 
                                                                         color: '#0468BF', 
                                                                         textAlign: 'center' 
                                                                     }}>
                                                                         Programar Mantenimiento
                                               </Typography>
                              
                             </DialogTitle>
       <DialogContent>
            <Box component="form" onSubmit={this.handleSubmit}>

              <FormControl fullWidth margin="normal">
  <Typography
    sx={{
      color: '#0468BF',
      fontSize: '18px',
      fontWeight: 400,
      ml: 1,
      mb: 1
    }}
  >
    Actividades
  </Typography>

  <TextField
    multiline
    minRows={3}
    name="actividades"
    id="actividades"
    label="Actividades del mantenimiento"
    value={this.state.actividades}
    onChange={this.handleChange}
    fullWidth
    variant="outlined"
    inputProps={{ maxLength: 200 }}
    error={Boolean(this.state.errors?.actividades)}
    helperText={this.state.errors?.actividades || ''}
  />

  {/* Contador alineado a la derecha */}
  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
      {(this.state.actividades?.length || 0)}/200
    </Typography>
  </Box>
</FormControl>
             

              <FormControl component="fieldset" fullWidth margin="normal">
  <Typography 
    variant="subtitle1"
    sx={{
      color: '#0468BF',
      fontSize: '18px',
      fontWeight: 400,
      mb: 2,
    }}
  >
    Frecuencia de Mantenimiento
  </Typography>
  
  <RadioGroup
    name="frecuencia"
    value={frecuencia}
    onChange={this.handleChange}
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(3, 1fr)' },
      gap: 1,
    }}
  >
    <FormControlLabel 
      value="riesgo" 
      control={<Radio size="small" />} 
      label={
        <Typography variant="body2">Según riesgo</Typography>
      }
      sx={{
        margin: 0,
        '& .MuiFormControlLabel-label': { fontSize: '14px' }
      }}
    />
    <FormControlLabel 
      value="bimestral" 
      control={<Radio size="small" />} 
      label={
        <Typography variant="body2">Bimestral</Typography>
      }
      sx={{ margin: 0 }}
    />
    <FormControlLabel 
      value="trimestral" 
      control={<Radio size="small" />} 
      label={
        <Typography variant="body2">Trimestral</Typography>
      }
      sx={{ margin: 0 }}
    />
    <FormControlLabel 
      value="semestral" 
      control={<Radio size="small" />} 
      label={
        <Typography variant="body2">Semestral</Typography>
      }
      sx={{ margin: 0 }}
    />
    <FormControlLabel 
      value="anual" 
      control={<Radio size="small" />} 
      label={
        <Typography variant="body2">Anual</Typography>
      }
      sx={{ margin: 0 }}
    />
    <FormControlLabel 
      value="fechasel" 
      control={<Radio size="small" />} 
      label={
        <Typography variant="body2">Fecha Seleccionada</Typography>
      }
      sx={{ margin: 0 }}
    />
  </RadioGroup>
</FormControl>

              <FormControl fullWidth margin="normal">
              <Typography sx={{
                               color: '#0468BF',
                               fontSize: '18px',
                               fontWeight: 400,
                               ml: 1,
                               mb:1
                             }}>
                              Fecha de Inicio
                             </Typography>
                <TextField
                  type="date"
                  name="fecha"
                  id="fecha"
                  label="Fecha de inicio"
                  value={this.state.fecha}
                  onChange={this.handleChange}
                  fullWidth
                  helperText={errors.fecha}
                  error={Boolean(errors.fecha)}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    min: "2020-01-01", 
                    max: "2030-12-31"
                  }}
                />
              </FormControl>

              <FormControl fullWidth margin="normal">
                <Typography sx={{
                  color: '#0468BF',
                  fontSize: '18px',
                  fontWeight: 400,
                  ml: 1,
                  mb: 1
                }}>
                  Responsable
                </Typography>
                <TextField
                  select
                  name="responsable"
                  id="responsable"
                  label="Seleccione un responsable"
                  value={this.state.responsable}
                  onChange={this.handleChange}
                  fullWidth
                  helperText={errors.responsable}
                  error={Boolean(errors.responsable)}
                  variant="outlined"
                >
                  <MenuItem value="Todos">Todos</MenuItem>
                  {this.props.tecnicos && this.props.tecnicos.map((handle, index) => (
                    <MenuItem key={index} value={handle}>
                      {handle}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
            </Box>
          </DialogContent>
                      


                    
                 
                </div>
               
                )}
            

           
            <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleClose}>
            <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
             </MyButton>

             {loading ? (
                <CircularProgress size={30} color="primary" className="login-progress" />
              ) : (
                this.state.aprobado.mensaje ? (
                  <MyButton tip="Continuar" onClick={this.handleClose}>
                    <FaCheckCircle color="#20B90C" className="icon-formulario" />
                  </MyButton>
                ) : (
                  <MyButton tip="Realizar Programación" onClick={this.handleSubmit}>
                    <FaPlus color="#03178C" className="icon-formulario" />
                  </MyButton>
                )
              )}
            
            

            
          </DialogActions>

            </Dialog>

            </Fragment>
        )
    }
}


//progMto
ProgramarMto.propTypes={
    progMto:PropTypes.func.isRequired,
    getTecnicos:PropTypes.func.isRequired,
    clearErrors:PropTypes.func.isRequired,
    UI:PropTypes.object.isRequired,
  };
  const mapStateToProps=(state)=>({
     user:state.user,
      data:state.data,
    UI:state.UI,
    equipo: state.data.equipo.credentials,
      handleuser: state.user.credentials.handle,
       tecnicos: state.user.tecnicos,
  });
  
  export default connect (mapStateToProps,{progMto,getTecnicos,clearErrors}) (ProgramarMto)
  
  
  

